// import { useGlobalContext } from "../context/GlobalContext";
import "./About.css";
import { Timeline } from "./Timeline";

export function About() {
  // const { lightThemeGlobal } = useGlobalContext();

  const openSocial = (socialLink: string) => {
    window.open(socialLink);
  };

  return (
    <div id="about" className="about-page flex">
      <div className="screen-max flex">
        <div className="about-page-container">
          {/* Section one - short description */}
          <div className="about-section-one">
            {/* Multiple about me titles */}
            <div className="about-title-container">
              <div className="about-title about-title-other ">
                About Me<span> .</span>
              </div>
              <div className="about-title ">
                About Me<span> .</span>
              </div>
              <div className="about-title about-title-other ">
                About Me<span> .</span>
              </div>
              <div className="about-title about-title-other ">
                About Me<span> .</span>
              </div>
            </div>

            <div className="about-body-container">
              <div className="about-body">
                Hey! I'm <span
                  className="about-body-link"
                  onClick={() => {
                    openSocial("https://www.linkedin.com/in/yashshivhare007/");
                  }}
                >
                  Yash
                </span>. I am a dedicated Computer Science
                Engineering student at IIIT Hyderabad, with a strong interest in
                software development, artificial intelligence, and machine
                learning. My academic journey has equipped me with skills in
                various programming languages and technologies, and I have
                hands-on experience through projects and internships. I am
                passionate about using technology to solve real-world problems
                and am always eager to learn and grow in the field of computer
                science.
                <span
                  className="about-body-link"
                  onClick={() => {
                    openSocial("https://www.linkedin.com/in/yashshivhare007/");
                  }}
                >
                  LinkedIn
                </span>
                .<br></br>
                <br></br>
                Feel free to contact me by{" "}
                <a
                  className="about-body-link"
                  href="mailto:shivhareyash007@gmail.com"
                >
                  Email
                </a>{" "}
                or check out my work on{" "}
                <span
                  className="about-body-link"
                  onClick={() => {
                    openSocial("https://github.com/YashShivhare007");
                  }}
                >
                  GitHub
                </span>
                .
              </div>

              {/* <div className="about-me-pic"> */}
              <img
                className="about-me-pic"
                src={process.env.PUBLIC_URL + "/assets/me.svg"}
                alt="aboutMyPic"
              />
              {/* </div> */}
            </div>
          </div>

          {/* Section two - timeline */}
          <div className="about-section-two flex">
            <div className="timeline-title">
              Experience <span>.</span>
            </div>
            <Timeline />
          </div>
        </div>
      </div>
    </div>
  );
}
